/**
 * Which deal models rate the cards. Investor-type experiences use the user's
 * saved pick (registerDefaults.dealModelIds, up to MAX_SELECTED_MODELS, ordered); the Home
 * buyer experience is fixed to its shared model. Saved through
 * PATCH /api/me/preferences { dealModelIds }.
 */
import type { UserPreferences } from '../../api/types'
import { DEFAULT_INVESTOR_MODEL_ID, HOME_BUYER_MODEL_ID, MAX_SELECTED_MODELS, type ExperienceSpec } from '../../experiences/registry'

const UUID = /^[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/

/** The saved ids, [] when none were saved, null when the saved value is unusable. */
export function savedModelIds(preferences: UserPreferences): string[] | null {
  const ids = preferences.registerDefaults.dealModelIds
  if (ids === undefined) return []
  if (!Array.isArray(ids) || ids.length > MAX_SELECTED_MODELS || ids.some(id => typeof id !== 'string' || !UUID.test(id)) || new Set(ids).size !== ids.length) return null
  return ids as string[]
}

/** The ids that rate the cards for this experience. */
export function activeModelIds(preferences: UserPreferences | undefined, spec: ExperienceSpec): string[] | null {
  if (spec.models.kind === 'fixed') return [spec.models.logicalModelId]
  if (!preferences) return null
  const saved = savedModelIds(preferences)
  if (saved === null) return null
  const investor = saved.filter(id => id !== HOME_BUYER_MODEL_ID)
  return saved.length > 0 && investor.length === 0 ? [DEFAULT_INVESTOR_MODEL_ID] : investor
}
